import { render, staticRenderFns } from "./index.vue?vue&type=template&id=372a9d8c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=372a9d8c&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=372a9d8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372a9d8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('372a9d8c')) {
      api.createRecord('372a9d8c', component.options)
    } else {
      api.reload('372a9d8c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=372a9d8c&scoped=true", function () {
      api.rerender('372a9d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/mainResponsibility/index.vue"
export default component.exports